export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_KEY,
  authDomain: 'datacom-data-centres.firebaseapp.com',
  databaseURL: 'https://datacom-data-centres.firebaseio.com',
  projectId: 'datacom-data-centres',
  storageBucket: 'datacom-data-centres.firebasestorage.app',
  messagingSenderId: '764186634332',
  appId: '1:764186634332:web:ea37bea75925208c7f1e99',
  measurementId: 'G-GS1ZCWR9XY',
};
